<template>
    <div>    
      <div class="row">
            <div class="col-md-12">
                <ul class="lista-dia-semana-dash text-center">
                    <li class="item-semana" v-bind:class="parseInt(diaselecionado) === 2 ? 'dia-selecionado' : ''" @click.prevent="mtdpicosvenda(2)">SEG</li>
                    <li class="item-semana" v-bind:class="parseInt(diaselecionado) === 3 ? 'dia-selecionado' : ''" @click.prevent="mtdpicosvenda(3)">TER</li>
                    <li class="item-semana" v-bind:class="parseInt(diaselecionado) === 4 ? 'dia-selecionado' : ''" @click.prevent="mtdpicosvenda(4)">QUA</li>
                    <li class="item-semana" v-bind:class="parseInt(diaselecionado) === 5 ? 'dia-selecionado' : ''" @click.prevent="mtdpicosvenda(5)">QUI</li>
                    <li class="item-semana" v-bind:class="parseInt(diaselecionado) === 6 ? 'dia-selecionado' : ''" @click.prevent="mtdpicosvenda(6)">SEX</li>
                    <li class="item-semana" v-bind:class="parseInt(diaselecionado) === 7 ? 'dia-selecionado' : ''" @click.prevent="mtdpicosvenda(7)">SAB</li>
                    <li class="item-semana" v-bind:class="parseInt(diaselecionado) === 1 ? 'dia-selecionado' : ''" @click.prevent="mtdpicosvenda(1)">DOM</li>
                </ul>
            </div>
            <div class="col-md-12">
                <graficobarra :titulo="''"
                                :agrupamento="agrupamentohoras"
                                :series="agrupamentoquantidades"
                ></graficobarra>
            </div>                                        
        </div>
    </div>
</template>

<script>
import { computed } from 'vue';
import util from '../../utilitarios/util';
import GraficoBarra from '../../components/cmpgraficobarra.vue';
import Skeletondashboard from '../../components/cmpskeletondashboard2.vue';
export default {
  name: "demvendedores",

  components:{
    'graficobarra'          : GraficoBarra,
    'dashboard_skeleton'   : Skeletondashboard
  },

  data : function name(params) {
    return {
        showpopover             : false,
        isloading               : false,  
        totalpedcompra          : 0,
        usuariologado           : this.$store.state.usuario,

        agrupamentohoras        : [],
        agrupamentoquantidades  : [],
        hrmaior                 : 0,
        diaselecionado          : 1,
    }
   
  },
  props: [
     'utodasfiliais',
     'idfilialmeta',
     'pdtini',
     'pdtfim',
     'lstfiliais',
    
  ],
  methods:{
        mtdpicosvenda(diasemana){
            var vself           = this;
            let loader          = vself.$loading.show();
            let periodo         = '"' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
            let parametros      = [
                {parametro: 'idclientesac', valor  : window.localStorage.getItem('idcliente')},                    
                {parametro: 'op',           valor : 'picovendas'},
                {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},                    
                {parametro: 'periodo',      valor : periodo},
                {parametro: 'diasemana',    valor : diasemana}
            ];
            let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/dashboard.php');
            retorno.then(function (response) {
                loader.hide();							
                vself.mtdmostrapicovendas(response.data.picovendas, diasemana);                                       				                    
            }).catch(function (response) {
                loader.hide();
            });                                
        },
        mtdmostrapicovendas(picovendas, diasemana){
            let vself = this;
            vself.diaselecionado = diasemana;
            vself.mtdhoramaiorquantidade(picovendas);
            vself.agrupamentohoras          = [];                            
            vself.agrupamentoquantidades    = [];                                        				
            let agr1 = [];
            let agr2 = [];
            if (picovendas.length > 0){
                for (let i = 0; i < picovendas.length; i++) {
                    picovendas[i];
                    agr1.push(picovendas[i].hora+':00');                            
                    agr2.push(picovendas[i].quantidade);
                }
            }
            vself.agrupamentohoras          = agr1;                            
            vself.agrupamentoquantidades    = agr2;                
        },
        mtdhoramaiorquantidade(arr) {            
            let maiorQuantidade = 0;
            let horaMaiorQuantidade = "";

            for (let i = 0; i < arr.length; i++) {
                const quantidade = parseInt(arr[i].quantidade);
                if (quantidade > maiorQuantidade) {
                maiorQuantidade = quantidade;
                horaMaiorQuantidade = arr[i].hora;
                }
            }
            this.hrmaior = horaMaiorQuantidade;
            // o código seguinte pega tanto a maior quanto a menor
            // let arrt = JSON.parse(JSON.stringify(arr));
            // arrt.sort(function(a, b) {
            //     var quantidadeA = parseInt(a.quantidade);
            //     var quantidadeB = parseInt(b.quantidade);
                
            //     if (quantidadeA < quantidadeB) {
            //         return 1;
            //     } else if (quantidadeA > quantidadeB) {
            //         return -1;
            //     } else {
            //         return 0;
            //     }
            // });
            // this.hrmaior = arr[0].hora;                
            // this.hrmenor = arr[arr.length - 1].hora;
        },
        mtdformatavalordecimal(valor){
			return util.formatarvalor(valor, '');
        },
        mtdresultadofaturamento(){
            var vself           = this;
            
            vself.$emit('handlerLoader', true);
            let periodo         = '"' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
        
    
            let parametros      = [
                {parametro: 'idclientesac', valor : window.localStorage.getItem('idcliente')},
                {parametro: 'op',           valor : 'dash'},
                {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},                    
                {parametro: 'periodo',      valor : periodo},
                {parametro: 'usuariologado',valor : JSON.stringify(vself.usuariologado)},
                {parametro: 'filiais',      valor : JSON.stringify(vself.lstfiliais)},
                {parametro: 'diasemana',    valor : util.diasemanaintmysql()},
                {parametro: 'filtrotarefas',valor : ''},//' and t.sttarefa=0'},
                {parametro: 'patharquivos', valor : ''},
            ];
            let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/dashboard.php');
            retorno.then(function (response) {
                //pedcompra pie 
        
                vself.mtdmostrapicovendas(response.data.picovendas, util.diasemanaintmysql());

                vself.$emit('handlerLoader', false);										
            }).catch(function (response) {
                vself.dadosvendedores = [];
                //loader.hide();
                vself.$emit('handlerLoader', false);	
            });                
        },
  },
  mounted(){


    setTimeout(() => {
         this.mtdresultadofaturamento();
    }, 3000);
   
  },
  computed:{
            
  },
}
</script>
